import React from 'react';
import { List } from '@mui/material';
import { CONSTANTS as Q_CONSTANTS } from 'src/components/questionnaire/Constants';
import { CONSTANTS, PEDIGREE } from 'src/components/Constants';
import MenuItemRow from '../MenuItemRow';
import { PersonIcon } from '../MenuIcons';
import { MENU_TONE } from '../menuTheme';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// Eleven gender-identity options, which `genderMappings` collapses to three drawn
// shapes. Each row carries the symbol IT would draw, so the consequence of the
// choice is visible before it is made — six of these land on the diamond, which
// is not obvious from the wording alone (TGCLOUD-1644).
const GenderMenu = ({
  node,
  memberRecords,
  setMemberRecords,
  handleClose,
  setPedigreeState
}) => {
  const t = useAutoTranslation();
  const data = node;

  // Optional-chained: a node with neither field set used to throw here rather
  // than simply highlighting nothing.
  const gender = (data?.genderIdentity ?? data?.gender ?? '').toLowerCase();

  const onChange = (value) => {
    const idx = memberRecords.findIndex((person) => data.pid === person.pid);

    memberRecords[idx] = {
      ...memberRecords[idx],
      genderIdentity: value,
      gender: CONSTANTS.genderMappings[value]
    };

    setMemberRecords([...memberRecords]);

    setPedigreeState((prev) => ({
      ...prev,
      save: PEDIGREE.saveStatus.IN_PROGRESS
    }));

    handleClose();
  };

  return (
    <List disablePadding>
      {Q_CONSTANTS.genderIdentityOptions.map((option) => (
        <MenuItemRow
          key={option.value}
          icon={<PersonIcon gender={CONSTANTS.genderMappings[option.value]} />}
          tone={MENU_TONE.person}
          // The stored value, translated at display only: it is what is saved
          // and compared.
          label={t(option.value)}
          selected={option.value.toLowerCase() === gender}
          onClick={() => onChange(option.value)}
        />
      ))}
    </List>
  );
};

export default GenderMenu;
